import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


import recentpostImag1 from './images/blogimage/blog/recent-posts/1.jpg';
import recentpostImag2 from './images/blogimage/blog/recent-posts/2.jpg';
import recentpostImag3 from './images/blogimage/blog/recent-posts/3.jpg';
import recentpostImag4 from './images/blogimage/blog/recent-posts/4.jpg';

import './images/blogimage/css/animate.css';
import './images/blogimage/css/splitting.css';
import './images/blogimage/css/main-LTR-1.css';
import './images/blogimage/css/all.min.css';
import NavbarComponent from './navbar';
import Footer from './footer';

// Utility function to create URL-friendly slugs
const slugify = (text) => {
    if (!text) return '';
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')      // Replace spaces with -
        .replace(/[^\w-]+/g, '')   // Remove all non-word chars
        .replace(/--+/g, '-')      // Replace multiple - with single -
        .replace(/^-+/, '')        // Trim - from start of text
        .replace(/-+$/, '');       // Trim - from end of text
};


const BlogPage = () => {
    const [posts, setPosts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [recentPosts, setRecentPosts] = useState([]);
    const [tags, setTags] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentCategoryName, setCurrentCategoryName] = useState('All Blogs');

    const postsPerPage = 11;

    const location = useLocation();
    const navigate = useNavigate();
    // MODIFIED: Destructure tagSlug here from useParams()
    const { categorySlug, tagSlug } = useParams(); // <--- IMPORTANT: Now includes tagSlug

    const [isTablet, setIsTablet] = useState(false);

    const checkWindowSize = () => {
        setIsTablet(window.innerWidth <= 1024);
    };

    useEffect(() => {
        checkWindowSize();
        window.addEventListener('resize', checkWindowSize);
        return () => {
            window.removeEventListener('resize', checkWindowSize);
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname, location.search]);

    useEffect(() => {
        setCurrentPage(1);
        setLoading(true);
        setError(null);

        const fetchBlogData = async () => {
            try {
                const initialResponse = await axios.get('https://fittex.io/jeevanapi/api/apptoodhublog?type=c');
                const initialData = initialResponse.data?.data;
                const fetchedCategories = Array.isArray(initialData?.blogCategoryInfo) ? initialData.blogCategoryInfo : [];
                const fetchedTags = Array.isArray(initialData?.blogTagInfo) ? initialData.blogTagInfo : [];
                const fetchedRecentPosts = Array.isArray(initialData?.blogInfo) ? initialData.blogInfo.slice(0, 5) : [];

                setCategories(fetchedCategories);
                setTags(fetchedTags);
                setRecentPosts(fetchedRecentPosts);

                let postsApiUrl = 'https://fittex.io/jeevanapi/api/apptoodhublog';
                const params = new URLSearchParams();
                let currentFilterApplied = false;
                let filterNameForDisplay = 'All Blogs'; // Default display name

                // 1. Prioritize categorySlug from URL path
                if (categorySlug) {
                    const matchedCategory = fetchedCategories.find(cat => slugify(cat.blog_Category) === categorySlug);
                    if (matchedCategory) {
                        params.append('categoryId', matchedCategory.blog_CategoryId);
                        filterNameForDisplay = matchedCategory.blog_Category;
                        currentFilterApplied = true;
                    } else {
                        setError(`Category "${categorySlug}" not found.`);
                        setPosts([]);
                        setLoading(false);
                        setCurrentCategoryName(`Category "${categorySlug}" not found.`);
                        return;
                    }
                }
                // NEW: Handle tagSlug from URL path (for /blogs/tags/tagname)
                else if (tagSlug) {
                    const matchedTag = fetchedTags.find(tag => slugify(tag.blog_Tag) === tagSlug);
                    if (matchedTag) {
                        params.append('FilterText', matchedTag.blog_Tag); // Send original tag name to API
                        filterNameForDisplay = `Tag: "${matchedTag.blog_Tag}"`;
                        currentFilterApplied = true;
                    } else {
                        setError(`Tag "${tagSlug}" not found.`);
                        setPosts([]);
                        setLoading(false);
                        setCurrentCategoryName(`Tag "${tagSlug}" not found.`);
                        return;
                    }
                }
                // 2. Handle SearchName from URL search parameter
                else if (location.search.includes('SearchName=')) {
                    const searchParams = new URLSearchParams(location.search);
                    const searchName = searchParams.get('SearchName');
                    if (searchName) {
                        params.append('FilterText', decodeURIComponent(searchName));
                        filterNameForDisplay = `Search: "${decodeURIComponent(searchName)}"`;
                        currentFilterApplied = true;
                    }
                }
                // 3. Handle legacy categoryId from URL search parameter (for backward compatibility)
                // Keep this for now if old links still exist, but prioritize slug-based.
                else if (location.search.includes('categoryId=')) {
                    const searchParams = new URLSearchParams(location.search);
                    const categoryId = searchParams.get('categoryId');
                    if (!isNaN(parseInt(categoryId))) {
                        params.append('categoryId', categoryId);
                        const matchedCategory = fetchedCategories.find(cat => cat.blog_CategoryId === parseInt(categoryId));
                        filterNameForDisplay = matchedCategory ? matchedCategory.blog_Category : 'Category Filtered';
                        currentFilterApplied = true;
                    }
                }
                // NOTE: If you previously had `location.search.includes('TagName=')`
                // and are fully transitioning to `/blogs/tags/:tagSlug`, you can remove that `else if` block.
                // It's still present in your provided code, but this new `tagSlug` block takes precedence.


                if (currentFilterApplied) {
                    postsApiUrl += '?' + params.toString();
                } else {
                    postsApiUrl += '?type=all';
                }
                setCurrentCategoryName(filterNameForDisplay);

                const filteredResponse = await axios.get(postsApiUrl);
                setPosts(Array.isArray(filteredResponse.data?.data?.blogInfo) ? filteredResponse.data.data.blogInfo : []);

            } catch (err) {
                console.error("Error fetching blog data:", err);
                setError("Failed to load blog posts. Please try again.");
                setPosts([]);
            } finally {
                setLoading(false);
            }
        };

        // MODIFIED: Added tagSlug to dependency array
        fetchBlogData();
    }, [categorySlug, tagSlug, location.search]); // Depend on categorySlug, tagSlug, and location.search

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        const term = searchTerm.trim();

        if (term) {
            navigate(`/blogs?SearchName=${encodeURIComponent(term)}`);
        } else {
            navigate('/blogs');
        }
    };

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
    const totalPages = Math.ceil(posts.length / postsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (loading) {
        return (
            <>
               
                <section className="blog blog-home mega-section">
                    <div className="container py-5 text-center">
                 
                    </div>
                </section>
                <Footer />
            </>
        );
    }

    if (error) {
        return (
            <>
            
                <section className="blog blog-home mega-section">
                    <div className="container py-5 text-center text-danger">
                        Error: {error}
                    </div>
                </section>
                <Footer />
            </>
        );
    }

    return (
        <>
    <div className="pricingnavbar menunavbar">
     <NavbarComponent />
     </div>

            <Helmet>
                <link
                    rel="icon"
                    href={`${process.env.PUBLIC_URL}/assets/Images/fav-icon/fav-icon.png`}
                />
                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Nunito:wght@400;500;600;700;800;900&display=swap"
                />
            </Helmet>

            <section className="blog blog-home mega-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="posts-grid row">
                                {currentPosts.length > 0 ? (
                                    currentPosts.map((post, index) => {
                                        const slug = slugify(post.blog_Header);
                                        return (
                                            <div className={`col-12 ${index !== 0 ? 'col-lg-6' : ''}`} key={index}>
                                                <div className="post-box">
                                                    <Link
                                                        target='_self'
                                                        className="read-more"
                                                        to={`/blogs/${slug}`}
                                                        state={{ blogId: post.blog_Id }}
                                                    >
                                                        <div className="post-img-wraper">
                                                            <div className="overlay-color"></div>
                                                            <i className="fas fa-search icon"></i>
                                                            <img className="post-img banner1" src={post.blog_Banner} alt={post.blog_Header} />
                                                        </div>
                                                    </Link>
                                                    <div className="post-summary">
                                                        <div className="post-info">
                                                            <Link
                                                                className="post-cat"
                                                                to={`/blogs/category/${slugify(post.blog_Category)}`}
                                                                state={{ categoryId: post.blog_CategoryId, categoryName: post.blog_Category }}
                                                            >
                                                                <i className="fas fa-list-alt icon"></i>{post.blog_Category}
                                                            </Link>
                                                            <span className="post-date"><i className="fas fa-history icon"></i>{post.blog_Date}</span>
                                                            <a className="post-author" href="#"><i className="fas fa-user icon"></i>{post.author}</a>
                                                            <span className="post-cat"><i className="fas fa-history icon"></i>{post.read_Time}</span>
                                                        </div>
                                                        <div className="post-text">
                                                            <Link
                                                                target='_self'
                                                                className="post-link"
                                                                to={`/blogs/${slug}`}
                                                                state={{ blogId: post.blog_Id }}
                                                            >
                                                                <h2 className="post-title">{post.blog_Header}</h2>
                                                            </Link>
                                                            <div key={post.id}>
                                                                <p className="post-excerpt">{post.title}</p>
                                                                <Link
                                                                    target='_self'
                                                                    className="read-more readtxt"
                                                                    to={`/blogs/${slug}`}
                                                                    state={{ blogId: post.blog_Id }}
                                                                    aria-label={`Read more about ${post.blog_Header}`}
                                                                >
                                                                    Read more<i className="fas fa-arrow-right icon"></i>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    !loading && <p>No posts found for this selection.</p>
                                )}
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-12 col-lg-4">
                            <div className="blog-sidebar">

                                {/* Search */}
                                <div className="search sidebar-box">
                                    <form className="search-form" onSubmit={handleSearchSubmit}>
                                        <input
                                            className="search-input"
                                            type="search"
                                            placeholder="Search Posts..."
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                        <button className="search-btn" type="submit"><i className="fas fa-search icon"></i></button>
                                    </form>
                                </div>
                                {/* Categories */}
                                <div className="cats sidebar-box">
                                    <h6 className="sidebar-box-title flex items-center justify-between">
                                        <span><i className="fas fa-list-alt icon"></i> Categories:</span>
                                        <Link to="/blogs" className="text-right spanalltxt">All</Link>
                                    </h6>
                                    <ul className="sidebar-list cats-list">
                                        {categories.length > 0 ? categories.map((cat, idx) => {
                                            const isActive = categorySlug && slugify(cat.blog_Category) === categorySlug;
                                            return (
                                                <li className={`cat-item ${isActive ? 'active-cat' : ''}`} key={idx} style={{ cursor: "pointer" }}>
                                                    <Link
                                                        className={`cat-link ${isActive ? 'active-cat-link' : ''}`}
                                                        to={`/blogs/category/${slugify(cat.blog_Category)}`}
                                                        state={{ categoryId: cat.blog_CategoryId, categoryName: cat.blog_Category }}
                                                    >
                                                        {cat.blog_Category}
                                                    </Link>
                                                    <Link
                                                        className={`cat-count ${isActive ? 'active-cat-count' : ''}`}
                                                        to={`/blogs/category/${slugify(cat.blog_Category)}`}
                                                        state={{ categoryId: cat.blog_CategoryId, categoryName: cat.blog_Category }}
                                                    >
                                                        {cat.blog_CategoryCnt}
                                                    </Link>
                                                </li>
                                            );
                                        }) : <li>No categories available.</li>}
                                    </ul>
                                </div>

                                {/* Recent Posts */}
                                <div className="recent-posts sidebar-box">
                                    <h6 className="sidebar-box-title"><i className="fas fa-history icon"></i>Recent Posts:</h6>
                                    <ul className="sidebar-list r-posts-list">
                                        {recentPosts.slice(0, 5).map((post, idx) => {
                                            const slug = slugify(post.blog_Header);
                                            return (
                                                <li className="r-post-item" key={idx}>
                                                    <Link
                                                        to={`/blogs/${slug}`}
                                                        state={{ blogId: post.blog_Id }}
                                                        className="r-post-link"
                                                    >
                                                        <div className="r-post-img-wraper">
                                                            <img className="r-post-img" src={post.blog_Banner} alt={post.blog_Header} />
                                                        </div>
                                                        <div className="content recentcontent">
                                                            <h6 className="r-post-title">{post.blog_Header}</h6>
                                                            <span className="r-post-date">{post.blog_Date}</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>

                                {/* Tags */}
                                <div className="tags sidebar-box">
                                    <h6 className="sidebar-box-title">
                                        <i className="fas fa-tags icon"></i>Tags:
                                    </h6>
                                    <ul className="sidebar-list tags-list">
                                        {tags.length > 0 ? tags.map((tag, idx) => {
                                            // ADDED: Define isActive for tags here
                                            const isActive = tagSlug && slugify(tag.blog_Tag) === tagSlug; // <--- ADD THIS LINE
                                            return (
                                                <li className={`tag-item ${isActive ? 'active-tag' : ''}`} key={idx}>
                                                    <Link
                                                        target="_self"
                                                        className={`tag-link ${isActive ? 'active-tag-link' : ''}`} // isActive used here
                                                        // MODIFIED: Use slugify for cleaner URL
                                                        to={`/blogs/tags/${slugify(tag.blog_Tag)}`} // <--- MODIFIED TO USE slugify
                                                    >
                                                        {tag.blog_Tag}
                                                    </Link>
                                                </li>
                                            );
                                        }) : <li>No tags available.</li>}
                                    </ul>
                                </div>

                                {/* Social */}
                                <div className="follow-us sidebar-box">
                                    <h6 className="sidebar-box-title"><i className="fas fa-heart icon"></i>Follow Us On:</h6>
                                    <div className="sc-wraper dir-row sc-size-32">
                                        <ul className="sc-list">
                                            <li className="sc-item">
                                                <a className="sc-link" href="https://www.facebook.com/fittex.io" target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-facebook-f sc-icon"></i>
                                                </a>
                                            </li>
                                            <li className="sc-item">
                                                <a className="sc-link" href="https://www.youtube.com/@Fittex_io" target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-youtube sc-icon"></i>
                                                </a>
                                            </li>
                                            <li className="sc-item">
                                                <a className="sc-link" href="https://www.instagram.com/fittex.io/" target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-instagram sc-icon"></i>
                                                </a>
                                            </li>
                                            <li className="sc-item">
                                                <a className="sc-link" href="https://www.linkedin.com/company/fittex-web/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-linkedin sc-icon"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Pagination */}
            <div className="col-12 blog">
                <nav className="posts-pagination">
                    <ul className="pagination justify-content-center">
                        <li className={`posts-page-item ${currentPage === 1 ? 'deactive-posts-page-item' : ''}`}>
                            <button className="posts-page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                <i className="fas fa-arrow-left icon"></i>
                            </button>
                        </li>

                        {Array.from({ length: totalPages }, (_, i) => (
                            <li key={i} className={`posts-page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                <button className="posts-page-link" onClick={() => handlePageChange(i + 1)}>
                                    {i + 1}
                                </button>
                            </li>
                        ))}

                        <li className={`posts-page-item ${currentPage === totalPages ? 'deactive-posts-page-item' : ''}`}>
                            <button className="posts-page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                <i className="fas fa-arrow-right icon"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            <Footer />
        </>
    );
};

export default BlogPage;